[
  {
    "id": "way",
    "x": 672,
    "y": 709.346,
    "w": 110,
    "h": 75.308
  },
  {
    "id": "callit",
    "x": 299,
    "y": 1514,
    "w": 112,
    "h": 36
  }
]
